import { ApprovalsReviewKind, ApprovalsReviewStatus } from './constants';

export const reviewKindToApprovalReviewStatus = {
  [ApprovalsReviewKind.DEFAULT]: ApprovalsReviewStatus.DEFAULT,
  [ApprovalsReviewKind.APPROVE]: ApprovalsReviewStatus.APPROVED,
  [ApprovalsReviewKind.DECLINE]: ApprovalsReviewStatus.DECLINED,
  [ApprovalsReviewKind.COMMENT]: ApprovalsReviewStatus.COMMENTED,
};
